import classNames from 'classnames';

import { sanitizeHtml } from '../../utils/sanitzeHtml';

import style from './raw-html.module.css';

interface RawHtmlProps {
  children: string;
  className?: string;
  id?: string;
}

const RawHtml = ({
  children,
  className,
  id,
}: RawHtmlProps) => {
  return (
    <div
      className={classNames(style.rawHtmlContainer, className)}
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }}
      id={id}
    />
  );
};

export default RawHtml;
